import { addInsert$, modal$ } from "../lib/state";
import { InsertType } from "../lib/types";
import { generateInsertId } from "../lib/util.functions";

class InsertButton extends HTMLElement {
  #abortController?: AbortController | null;
  #type?: InsertType;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.addEventListener('click' , (e: MouseEvent) => {
      if (this.#type === 'custom') {
        modal$.next({ contentType: 'custom-insert', show: true });
      } else if (this.#type === 'cushion') {
        modal$.next({ contentType: 'cushion-insert', show: true });
      } else if (this.#type) {
        addInsert$.next({
          type: this.#type,
          id: generateInsertId(),
          x: 0,
          y: 0,
          unitWidth: 0,
          unitHeight: 0
        });
      }
    }, { signal });
  }

  disconnectedCallback(): void {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  static get observedAttributes(): string[] {
    return ['data-type'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'data-type') {
      this.#type = newValue as InsertType;
      switch (this.#type) {
        case 'belt':
          this.innerHTML = `
            <svg-icon icon="belt" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Tie/Belt</span>
              <span>4 ¾” x 4 ¾”</span>
            </div>
          `;
          break;

        case 'earrings':
          this.innerHTML = `
            <svg-icon icon="earrings" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Earrings</span>
              <span>2” x 2”</span>
            </div>
          `;
          break;

        case 'sunglasses':
          this.innerHTML = `
            <svg-icon icon="sunglasses" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Sunglasses</span>
              <span>6 ¾” x 2 ¾” </span>
            </div>
          `;
          break;

        case 'necklace':
          this.innerHTML = `
            <svg-icon icon="necklace" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Necklaces</span>
              <span>10” x 2”</span>
            </div>
          `;
          break;

        case 'watch':
          this.innerHTML = `
            <svg-icon icon="watch" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Watch/Bracelets</span>
              <span>3 ¾” x 3 ¾”</span>
            </div>
          `;
          break;

        case 'square':
          this.innerHTML = `
            <svg-icon icon="square" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Plain Square</span>
              <span>2” x 2”</span>
            </div>
          `;
          break;

        case 'custom':
          this.innerHTML = `
            <svg-icon icon="plus" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Custom Insert</span>
            </div>
          `;
          break;

        case 'cushion':
          this.innerHTML = `
            <svg-icon icon="plus" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Add Ring Cushion</span>
            </div>
          `;
          break;

        case 'pillow':
          this.innerHTML = `
            <svg-icon icon="plus" size="large"></svg-icon>
            <div class="insert-group__btn__content">
              <span>Add Watch Pillow</span>
            </div>
          `;
          break;
      
        default:
          break;
      }
    }
  }
}

customElements.define('insert-button', InsertButton);